export var SPACE_BAR_KEYCODE = 32;